import styled from "@emotion/styled"
import {
	durationSm,
	easeInOut,
	getFocusVisibleStyle,
	radiusXl,
	proseTextSmStyle,
} from "@porsche-design-system/components-react/emotion"
import { defineMessages, FormattedMessage } from "react-intl"

const messages = defineMessages({
	buttonLabel: {
		defaultMessage: "Feedback",
		id: "feedback.buttonLabel",
	},
})

export const FeedbackButton = (props: any) => {
	return (
		<StyledButton {...props} type="button" aria-haspopup="dialog">
			<FormattedMessage {...messages.buttonLabel} />
		</StyledButton>
	)
}

const StyledButton = styled.button`
	display: flex;
	box-sizing: border-box;
	appearance: none;
	text-decoration: none;
	${() => ({ ...proseTextSmStyle })}
	border: 2px solid #4493F6;
	${getFocusVisibleStyle()}
	border-radius: ${radiusXl} ${radiusXl} 0 0;
	background: #4493F6;
	color: #fbfcff;
	transition: background-color ${durationSm} ${easeInOut}, border-color ${durationSm} ${easeInOut}, color ${durationSm} ${easeInOut};
	padding: calc(0.8125 * 16px) max(calc(1.625 * 16px), 4px) ;
	cursor: pointer;
	margin: 0;

	position: fixed;
	inset-inline-end: 0;
	bottom: 50%;
	transform-origin: bottom right;
	transform: translate3d(0, -100%, 0) rotate(270deg);
	z-index: 5;
	
	:dir(rtl) {
		transform-origin: bottom left;
		transform: translate3d(0, -100%, 0) rotate(90deg);
	}

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			border-color: #60a3f7;
			background: #60a3f7;
		}
	}
`
